import { FC, useState, useEffect } from 'react'
import { useParams, useHistory } from 'react-router-dom'

import * as LRS from '../api/LRS'
import { isDebug } from '../configs'
import { isSim, isLab, getOverallStudentView } from '../Reporting'

import { useSessionContext, useStudentContext } from '../contexts'

import { LLModuleProfile, TSModuleProfile } from '../interfaces/ModuleTypes'
import { DataTiles, TileView } from './dataview'
import { LoadingIndicator, CriticalError } from '.'
import { LearningProgress, SkillRating } from './student'

import { PrimaryHeader } from '../styles/Styles'

type IndividualDataType = {
    labs: LLModuleProfile[]
    sims: TSModuleProfile[]
}

const IndividualData: FC = () => {
    const { user } = useSessionContext()
    const { currentStudent, setCurrentStudent } = useStudentContext()

    const [error, setError] = useState('')
    const [studentModules, setStudentModules] = useState<IndividualDataType>()
    const [dataTiles, setDataTiles] = useState<DataTiles[]>()

    const history = useHistory()
    const { studentId } = useParams<{ studentId: string }>()

    useEffect(() => {
        if ((currentStudent && currentStudent.userId === studentId) || !user) return
        isDebug && console.log('Fetch Student effect for studentId :', studentId)

        const fetchData = async () => setCurrentStudent(await LRS.getStudentProfileByUserID(studentId, user.lrsDbName))

        fetchData()
            .catch(error => setError(error.toString()))

    }, [currentStudent, history, setCurrentStudent, studentId, user])


    useEffect(() => {
        if (studentModules || !currentStudent || currentStudent.userId !== studentId || !user) return
        isDebug && console.log(`Fetch Student Data effect for currentStudentId ${currentStudent.userId}`)
        const fetchData = async () => {

            const profiles = await LRS.getAllModuleProfilesByUserID(currentStudent.userId, user.lrsDbName)
            const simProfiles: TSModuleProfile[] = profiles.filter(isSim)
            const labProfiles: LLModuleProfile[] = profiles.filter(isLab)
            setStudentModules({
                labs: labProfiles,
                sims: simProfiles
            })
        }
        fetchData()
    }, [studentModules, user, studentId, setCurrentStudent, currentStudent])

    useEffect(() => {
        if (dataTiles || !currentStudent || currentStudent.userId !== studentId || !studentModules) return
        isDebug && console.log('Set tiles effect.')
        const tiles = getOverallStudentView(currentStudent, studentModules.sims, studentModules.labs)
        setDataTiles(tiles)
    }, [currentStudent, dataTiles, studentId, studentModules])

    if (error) return <CriticalError message={error} />
    if (!dataTiles || !studentModules) return <LoadingIndicator loading={true} text={'Loading profile...'} />
    const { labs, sims } = studentModules
    return (
        <>
            <TileView dataTiles={dataTiles} />
            <PrimaryHeader variant={'h4'} spacing={5}>
                {`Learning Progress`}
            </PrimaryHeader>
            <LearningProgress labs={labs} />
            <PrimaryHeader variant={'h4'}>
                {`Skill Rating`}
            </PrimaryHeader>
            <SkillRating sims={sims} />
        </>
    )
}

export default IndividualData
